// extracted by mini-css-extract-plugin
export default {"OutputChart":"OutputChart_OutputChart__IRFCC"};